import { Component, HostBinding, OnInit } from '@angular/core';
import { User } from '../../models/user';
import { UserService } from '../../shared/user.service';
import { EditUserModalComponent } from '../shared/edit-user-modal/edit-user-modal.component';
import { ModalService } from '../../core/modal.service';

@Component({
  selector: 'cw-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {
  @HostBinding('class') className = 'content-container';
  users: User[];

  constructor(private userService: UserService,
              private modal: ModalService) {
  }

  showCreate() {
    const modalRef = this.modal.open(EditUserModalComponent);
    modalRef.componentInstance.initCreate();
    modalRef.result.then(user => {
      this.loadUsers();
    });
  }

  ngOnInit() {
    this.loadUsers();
  }

  private loadUsers() {
    this.userService.get().subscribe(users => {
      this.users = users;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users-list/users-list.component.ts